import { JsonConverter } from 'json2typescript';
import { HvlEnumConverter } from '@hvlng/framework-bff/util';

export enum EnumProcessActionType {
    REVISE = 'REVISE',
    REJECT = 'REJECT',
    APPROVE = 'APPROVE',
    PARTIAL_APPROVED = 'PARTIAL_APPROVED',
}

@JsonConverter
export class EnumProcessActionTypeConverter extends HvlEnumConverter<EnumProcessActionType> {
    constructor() {
        super(EnumProcessActionType, 'EnumProcessActionType');
    }
}
